import { API_URL } from "../../../../components/App/constants";

export const IMAGE_URL = API_URL;

export const STATUS_DEFAULT = 0;
export const STATUS_LOADING = 1;
export const STATUS_LOADED = 2;
